<template>
  <div>
    <div class="course-content">
      <el-collapse
        v-model="activeNames"
        @change="handleChange"
        class="table-con"
      >
        <el-collapse-item
          v-for="item in homeworkList"
          :key="item.id"
          :name="item.id"
        >
          <template slot="title">
            <span style="width: 90%">{{ item.name }}</span>
            <i :class="activeFn(item.id) != -1 ? 'downIcon' : 'upIcon'"></i>
          </template>
          <el-collapse-item
            class="chapterList-item"
            v-for="(list, index) in item.chapterList"
            :key="list.chapter_id"
            :name="list.chapter_id"
          >
            <template slot="title">
              <span style="width: 90%">{{ `${index + 1}、${list.name}` }}</span>
              <i
                :class="activeFn(list.chapter_id) != -1 ? 'downIcon' : 'upIcon'"
              ></i>
            </template>
            <div
              class="video-con"
              v-for="(videoItem, i) in list.videoList"
              :key="i"
            >
              <p class="video-name">
                <span class="video-title" :title="videoItem.video_name">{{
                  videoItem.video_name
                }}</span>
              </p>
              <p class="video-info">
                <span
                  >视频时长：{{ secondsToTimeFormat(videoItem.duration) }}</span
                >
                <span
                  >累计观看：{{
                    secondsToTimeFormat(
                      videoItem.view_time > videoItem.duration
                        ? videoItem.duration
                        : videoItem.view_time
                    )
                  }}</span
                >
                <span
                  >完成率：<span style="color: #fd6466"
                    >{{
                      Number(videoItem.complete_rate) > 100
                        ? 100
                        : videoItem.complete_rate
                    }}%</span
                  ></span
                >
              </p>
            </div>
          </el-collapse-item>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getHost } from '../../utils/useProxyApi';
export default {
  props: ['classId'],
  data() {
    return {
      keyword: '',
      activeNames: [],
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      homeworkList: [],
      total: 0,
      page: 1,
    };
  },
  created() {
    this.getHomeworkList();
  },

  methods: {
    activeFn(data) {
      return this.activeNames.indexOf(data);
    },
    secondsToTimeFormat(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;

      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      secs = secs < 10 ? '0' + secs : secs;

      return hours + ':' + minutes + ':' + secs;
    },
    handleChange(val) {
      console.log(val);
    },
    async getHomeworkList() {
      // 获取列表数据
      const data = {
        class_id: this.classId,
        page: this.page,
        page_nums: 10,
      };
      // https://test-school.tenghuiketang.com ${getHost()}
      const res = await this.$tenghuiApi.post(
        `${getHost()}/studentPersonalCenter/getMobileWatchDataInfo`,
        data
      );
      if (res.data.code == 200) {
        // 对节数据处理
        res.data.data.list.forEach((ele) => {
          const chapterList = [];
          // 合并节
          ele.chapter_video_list.forEach((list) => {
            if (!chapterList.some((c) => c.chapter_id == list.chapter_id)) {
              const videoList = ele.chapter_video_list.filter(
                (i) => i.chapter_id === list.chapter_id
              );
              chapterList.push({
                name: list.name,
                chapter_id: list.chapter_id,
                videoList,
              });
            }
          });
          ele.chapterList = chapterList;
        });

        this.homeworkList = res.data.data.list;
        console.log(this.homeworkList, '观看数据');
        this.total = res.data.data.total;
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getHomeworkList();
    },
    handleSearch() {
      this.page = 1;
      this.getHomeworkList();
    },
  },
};
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
th {
  font-weight: normal;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
  .header {
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    display: flex;
    align-items: center;
    .search-box {
      width: 180px;
      margin-left: auto;
      ::v-deep .el-input__inner {
        border: none;
        background: #f7f7f7;
        border-radius: 18px;
      }
      ::v-deep .el-input__suffix {
        color: #1872ed;
      }
      ::v-deep .el-input__suffix {
        top: 9px;
        right: 10px;
        cursor: pointer;
      }
    }
  }
}
.title {
  font-size: 20px;
  color: #202020;
}
.red-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: red;
  border-radius: 50%;
  margin-left: 5px;
}
.course-content {
  margin-top: 20px;
  box-sizing: border-box;
  font-size: 14px;
  min-height: 400px;
  max-height: 700px;
  overflow-y: scroll;
  /* 滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px; /* 高宽分别对应横竖滚动条的尺寸 */
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(178, 178, 178, 0.2);
    background: #d7d7d7;
  }
  // &::-webkit-scrollbar-track {
  //   /*滚动条里面轨道*/
  //   box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   border-radius: 10px;
  //   background: #ededed;
  // }

  ::v-deep .table-con {
    border-top: none !important;
    .el-collapse-item__header {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #20242f;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      .el-collapse-item__arrow {
        /* 隐藏原箭头 */
        display: none;
      }
      /* 添加自定义图标 */
      .downIcon {
        margin-right: 5px;
        width: 14px;
        height: 14px;
        display: inline-block;
        background: url('../../assets/mofang/up.png') no-repeat;
      }
      .upIcon {
        margin-right: 5px;
        width: 14px;
        height: 14px;
        display: inline-block;
        background: url('../../assets/mofang/up.png') no-repeat;
        transform: rotate(-180deg);
      }
    }
    .el-collapse-item__content {
      .chapterList-item {
        padding-left: 18px;
        .el-collapse-item__header {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #202020;
          border-bottom: none;
        }
        .el-collapse-item__wrap {
          border-bottom: none;
        }
        .el-collapse-item__content {
          display: flex;
          flex-direction: column;
          align-items: center;
          .video-con {
            width: 840px;
            height: 82px;
            background: #f9fbff;
            border-radius: 8px;
            margin-bottom: 16px;
            padding: 0 16px;
            box-sizing: border-box;
            p {
              height: 50%;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .video-name {
              .video-title {
                color: #202020;
                font-weight: 400;
                font-size: 14px;
                font-family: PingFang SC, PingFang SC-400;
                width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .video-info {
              span {
                font-size: 14px;
                color: #666;
              }
            }
          }
        }
      }
    }
  }
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #1872ed;
}
</style>
